import React, { useEffect, useState } from "react";
import { MasterHeading } from "../../../utils/helperData";
import { IoIosSearch } from "react-icons/io";
import { CgAddR } from "react-icons/cg";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  GetSurfaceMaster,
  deleteSurafceMaster,
  editSufaceMaster,
} from "../../../../redux/action/Master/MasterAction";
import { ADD_SURFACE_MASTER } from "../../../utils/RouteConstant";
import Pagination from "../../../customComponent/Pagination";
import MasterTable from "../MasterTable/MasterTable";
import DeleteConfirmationModal from "../MasterTable/DeleteConfirmModal";

const SurfaceMaster = () => {
  const [editRowId, setEditRowId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteRowId, setDeleteRowId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [editedData, setEditedData] = useState({
    name: "",
    status: 1,
    master_id: "",
    sequence: "",
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { masterdata, error } = useSelector((state) => state.master);

  useEffect(() => {
    dispatch(GetSurfaceMaster());
  }, [dispatch]);

  const handleEditDetails = (item) => {
    setEditRowId(item._id);
    setEditedData({
      name: item.name,
      status: item.status,
      master_id: item._id,
      sequence: item?.sequence,
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSaveChanges = async () => {
    try {
      await dispatch(editSufaceMaster(editedData));
      setEditRowId(null);
      dispatch(GetSurfaceMaster());
    } catch (error) {
      console.error("Error saving changes:", error);
    }
  };

  const handleDeleteClick = (id) => {
    setShowDeleteModal(true);
    setDeleteRowId(id);
  };

  const handleDeleteConfirm = async () => {
    const result = await dispatch(deleteSurafceMaster(deleteRowId));
    if (result.success) {
      setShowDeleteModal(false);
      dispatch(GetSurfaceMaster());
    } else {
      console.error("Error deleting description:", error);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setDeleteRowId(null);
  };

  const handleAddSurface = () => {
    navigate(ADD_SURFACE_MASTER);
  };

  const filteredData = masterdata?.list?.filter((item) =>
    // item.name.toLowerCase().includes(searchQuery.toLowerCase())
    item?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const rowsPerPageOptions = [10, 20, 50, 100, "All"];

  const indexOfLastItem = currentPage * rowsPerPage;
  const indexOfFirstItem = indexOfLastItem - rowsPerPage;
  const currentItems = filteredData?.slice(indexOfFirstItem, indexOfLastItem);
  const totalCount = filteredData?.length;
  const totalPages =
    rowsPerPage === "All" ? 1 : Math.ceil(totalCount / rowsPerPage);

  const handleRowsPerPageChange = (event) => {
    const value = event.target.value;
    if (value === "All") {
      setRowsPerPage(totalCount);
      setCurrentPage(1);
    } else {
      setRowsPerPage(Number(value));
      setCurrentPage(1);
    }
  };
  return (
    <div className="p-4">
      <h2 className="text-3xl font-bold mb-6">Surface Master</h2>
      <div className="flex flex-col sm:flex-row justify-between items-center mb-6 space-y-4 sm:space-y-0 sm:space-x-4">
        <div className="relative w-full sm:w-64 flex-grow sm:flex-grow-0">
          <input
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full lg:w-[400px] pl-10 pr-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          <IoIosSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
        </div>
        <button
          onClick={handleAddSurface}
          className="w-full sm:w-auto bg-[#1C3664] text-white px-4 py-2 rounded-lg flex items-center justify-center hover:bg-blue-900 transition-colors"
        >
          <CgAddR className="mr-2" />
          Add New Surface
        </button>
      </div>
      <MasterTable
        MasterHeading={MasterHeading}
        currentItems={currentItems}
        indexOfFirstItem={indexOfFirstItem}
        editRowId={editRowId}
        editedData={editedData}
        handleInputChange={handleInputChange}
        handleSaveChanges={handleSaveChanges}
        handleEditDetails={handleEditDetails}
        handleDeleteClick={handleDeleteClick}
      />
      <DeleteConfirmationModal
        open={showDeleteModal}
        title="Confirm Deletion"
        message="Are you sure you want to remove this Surface Master?"
        onConfirm={handleDeleteConfirm}
        onCancel={handleDeleteCancel}
        error={error}
      />
      <div className="flex items-center justify-end mb-4 space-x-3">
        <div className="flex items-center mt-6 ">
          <label htmlFor="rows-per-page" className="mr-2">
            Rows per page:
          </label>
          <select
            id="rows-per-page"
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
            className="border border-solid border-2 h-[34px] rounded p-1 text-gray-500"
          >
            {rowsPerPageOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        {totalPages > 1 && rowsPerPage !== "All" && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        )}
      </div>
    </div>
  );
};

export default SurfaceMaster;
